"use strict";
import ApiService from "../services/api_service";
import { EmailWithoutDocuments } from "./email_without_documents";
import { emailService } from "../services/email_service";
import DataStoreService from "./data_store_service";
import { History } from "react-router";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { maybePrefetchNextFlowModeItem } from "./flow_mode/flow_mode_service";
var EmailPage = React.createClass({
  mixins: [History],
  propTypes: {
    location: React.PropTypes.object.isRequired
  },
  getInitialState: function() {
    return {
      isLoaded: false
    };
  },
  componentDidMount: function() {
    var id = this.props.params.id;
    emailService.getWithId(id, true).then(function(email) {
      var parent = email.parent;
      if (parent) {
        const exceptions = _.some(parent.exceptioned_items, function(item) {
          return item.state !== "complete";
        });
        const exceptionedItem = exceptions[0];
        if (exceptionedItem) {
          if (exceptionedItem.owner_type == "DocumentGroup") {
            $.get("/api/document_groups/" + exceptionedItem.owner_id).then(function(data) {
              this.setState({
                email,
                parent,
                documentGroup: data.document_group,
                isLoaded: true
              });
            }.bind(this));
            return;
          }
        }
      }
      this.setState({
        email,
        parent,
        isLoaded: true
      });
    }.bind(this));
    maybePrefetchNextFlowModeItem(this.props.location);
  },
  setCarrier: function(carrierEvent) {
    return $.post("/api/email_messages/" + this.state.email.id + "/set_carrier", {
      carrier_id: carrierEvent.carrierId
    }).then(function(data) {
      this.setState({
        email: _.extend(this.state.email, data.email_message)
      });
      return DataStoreService.updateStores(data);
    }.bind(this));
  },
  returningMethods: function() {
    return {
      sendEmail: this.sendEmail,
      onComplete: this.onComplete
    };
  },
  onComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  sendEmail: function(params) {
    return ApiService.addErrorHandler($.post("/api/email_messages", params).then(function(r) {
      return DataStoreService.updateStores(r.data);
    }));
  },
  render: function() {
    if (this.state.isLoaded) {
      return /* @__PURE__ */ React.createElement("div", { className: "row general-container reply-container" }, /* @__PURE__ */ React.createElement(
        EmailWithoutDocuments,
        {
          documentGroup: this.state.documentGroup,
          email: this.state.email,
          location: this.props.location,
          returningMethods: this.returningMethods(),
          carrierSetter: { onSetCarrier: this.setCarrier }
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  }
});
export default EmailPage;
